export const eventColors = {
  publicEventColor: '#0099FF',
  companyEventColor: '#FFDA55',
}
